import { mergeSettings, mergeScopedSettings } from './mergeSettings';
/**
 * Merge props and customizations giving priority to props over context.
 * NOTE: This function will always perform multiple merge operations. Use with caution.
 * @param props - New settings to merge in.
 * @param parentContext - Context containing current settings.
 * @returns Merged customizations.
 */
export function mergeCustomizations(props, parentContext) {
  var _a = (parentContext || {}).customizations,
    customizations = _a === void 0 ? {
      settings: {},
      scopedSettings: {}
    } : _a;
  return {
    customizations: {
      settings: mergeSettings(customizations.settings, props.settings),
      scopedSettings: mergeScopedSettings(customizations.scopedSettings, props.scopedSettings),
      inCustomizerContext: true
    }
  };
}